var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowedUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.288,
    height: 21.516,
    viewBox: "0 0 20.288 21.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7505",
    "data-name": "Rectangle 7505",
    width: 20.288,
    height: 21.516,
    transform: "translate(0 0)",
    fill: "#505465"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22533",
    "data-name": "Group 22533",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13258",
    "data-name": "Path 13258",
    d: "M28.546,5.205A5.211,5.211,0,1,1,23.338,0a5.219,5.219,0,0,1,5.208,5.206",
    transform: "translate(-14.655 0.001)",
    fill: "#505465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13259",
    "data-name": "Path 13259",
    d: "M7.949,65.064A5.744,5.744,0,0,1,10.1,60.575c-.825-.05-1.66-.035-2.486-.037A7.552,7.552,0,0,0,0,67.886c-.024.639.16.832.8.832H9.258a5.732,5.732,0,0,1-1.309-3.654",
    transform: "translate(0 -48.948)",
    fill: "#505465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13260",
    "data-name": "Path 13260",
    d: "M54.888,55.9A5.408,5.408,0,1,0,60.3,61.3,5.408,5.408,0,0,0,54.888,55.9M54.6,64.184,51.912,61.5l1.083-1.083,1.6,1.6,3.051-3.051L58.73,60.05Z",
    transform: "translate(-40.007 -45.196)",
    fill: "#505465"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowedUp);
export default __webpack_public_path__ + "static/media/Followed-Up.a43308c29f18ccaf133b8fd74cabe808.svg";
export { ForwardRef as ReactComponent };